// Friendly labels for permission keys & modules (used by the matrix UI).
export const MODULE_LABELS = {
  dashboard: { en: "Dashboard", id: "Dasbor" },
  orders: { en: "Orders", id: "Pesanan" },
  purchasing: { en: "Purchasing", id: "Pembelian" },
  delivery: { en: "Delivery", id: "Pengiriman" },
  receiving: { en: "Receiving", id: "Penerimaan" },
  inventory: { en: "Inventory", id: "Inventaris" },
  stock_take: { en: "Stock Take", id: "Stok Opname" },
  waste: { en: "Waste", id: "Barang Rusak" },
  employee_meal: { en: "Employee Meal", id: "Konsumsi Karyawan" },
  sales: { en: "Sales", id: "Penjualan" },
  leakage: { en: "Leakage & Variance", id: "Kebocoran & Selisih" },
  production: { en: "Central Production", id: "Produksi Central" },
  pricing: { en: "Margin & Pricing", id: "Marjin & Harga" },
  users: { en: "Users", id: "Pengguna" },
  reports: { en: "Reports", id: "Laporan" },
  central_ops: { en: "Central Operations", id: "Operasi Pusat" },
  purchase_records: { en: "Purchases", id: "Pembelian" },
  meja_prepare: { en: "Meja Prepare", id: "Meja Prepare" },
  kitchen_warehouse: { en: "Kitchen & Warehouse", id: "Dapur & Gudang" },
  price_changes: { en: "Raw Material Price Changes", id: "Perubahan Harga Bahan Baku" },
  ai_assistant: { en: "AI Assistant", id: "Asisten AI" },
  recipe_coverage: { en: "Recipe Coverage", id: "Cakupan Resep" },
  finance: { en: "Finance", id: "Keuangan" },
  ai_cfo: { en: "AI CFO", id: "AI CFO" },
  accounting: { en: "Accounting", id: "Akuntansi" },
  integrity: { en: "Data Integrity", id: "Integritas Data" },
  bank_import: { en: "Bank Statement Intelligence", id: "Intelijen Rekening Koran" },
  hr: { en: "HRD (Human Resources)", id: "HRD (Sumber Daya Manusia)" },
};

export const PERMISSION_LABELS = {
  view_dashboard: { en: "View dashboard", id: "Lihat dasbor" },
  export_dashboard: { en: "Export dashboard", id: "Ekspor dasbor" },
  view_orders: { en: "View orders", id: "Lihat pesanan" },
  create_orders: { en: "Create orders", id: "Buat pesanan" },
  edit_orders: { en: "Edit orders", id: "Ubah pesanan" },
  cancel_orders: { en: "Cancel orders", id: "Batalkan pesanan" },
  approve_orders: { en: "Approve orders", id: "Setujui pesanan" },
  view_purchasing: { en: "View purchasing", id: "Lihat pembelian" },
  create_po: { en: "Create PO", id: "Buat PO" },
  edit_po: { en: "Edit PO", id: "Ubah PO" },
  approve_po: { en: "Approve PO", id: "Setujui PO" },
  view_delivery: { en: "View delivery", id: "Lihat pengiriman" },
  create_delivery: { en: "Create delivery", id: "Buat pengiriman" },
  edit_delivery: { en: "Edit delivery", id: "Ubah pengiriman" },
  view_receiving: { en: "View receiving", id: "Lihat penerimaan" },
  receive_goods: { en: "Receive goods", id: "Terima barang" },
  report_discrepancy: { en: "Report discrepancy", id: "Laporkan selisih" },
  view_inventory: { en: "View inventory", id: "Lihat inventaris" },
  edit_inventory: { en: "Edit inventory", id: "Ubah inventaris" },
  stock_adjustment: { en: "Stock adjustment", id: "Penyesuaian stok" },
  transfer_stock: { en: "Transfer stock", id: "Transfer stok" },
  view_stock_take: { en: "View stock take", id: "Lihat stok opname" },
  create_stock_take: { en: "Create stock take", id: "Buat stok opname" },
  approve_stock_take: { en: "Approve stock take", id: "Setujui stok opname" },
  reopen_stock_take: { en: "Reopen stock take", id: "Buka ulang stok opname" },
  view_waste: { en: "View waste", id: "Lihat barang rusak" },
  create_waste: { en: "Create waste", id: "Catat barang rusak" },
  view_employee_meal: { en: "View employee meal", id: "Lihat konsumsi karyawan" },
  create_employee_meal: { en: "Create employee meal", id: "Catat konsumsi karyawan" },
  approve_waste: { en: "Approve waste", id: "Setujui barang rusak" },
  view_sales: { en: "View sales", id: "Lihat penjualan" },
  create_sales: { en: "Create sales", id: "Input penjualan" },
  import_sales: { en: "Import sales", id: "Impor penjualan" },
  view_import_history: { en: "View import history", id: "Lihat riwayat impor" },
  edit_sales: { en: "Edit sales", id: "Ubah penjualan" },
  view_leakage: { en: "View leakage", id: "Lihat kebocoran" },
  export_leakage: { en: "Export leakage", id: "Ekspor kebocoran" },
  view_production: { en: "View production", id: "Lihat produksi" },
  manage_production_recipes: { en: "Manage production recipes", id: "Kelola resep produksi" },
  create_production: { en: "Create production", id: "Buat produksi" },
  view_production_dashboard: { en: "View production dashboard", id: "Lihat dasbor produksi" },
  view_margin_dashboard: { en: "View margin dashboard", id: "Lihat dasbor marjin" },
  manage_branch_pricing: { en: "Manage branch pricing", id: "Kelola harga cabang" },
  view_users: { en: "View users", id: "Lihat pengguna" },
  create_users: { en: "Create users", id: "Buat pengguna" },
  edit_users: { en: "Edit users", id: "Ubah pengguna" },
  delete_users: { en: "Delete users", id: "Hapus pengguna" },
  export_pdf: { en: "Export PDF", id: "Ekspor PDF" },
  export_excel: { en: "Export Excel", id: "Ekspor Excel" },
  // Central operations
  view_central_ops: { en: "View central operations", id: "Lihat operasi pusat" },
  // Purchases (records)
  view_purchase_central: { en: "View central purchases", id: "Lihat pembelian pusat" },
  create_purchase_central: { en: "Create central purchase", id: "Buat pembelian pusat" },
  view_purchase_branch: { en: "View branch purchases", id: "Lihat pembelian cabang" },
  create_purchase_branch: { en: "Create branch purchase", id: "Buat pembelian cabang" },
  // Meja Prepare
  view_prepare: { en: "View prepare", id: "Lihat persiapan" },
  create_prepare: { en: "Create prepare", id: "Buat persiapan" },
  approve_prepare: { en: "Approve prepare", id: "Setujui persiapan" },
  view_prepare_dashboard: { en: "View prepare dashboard", id: "Lihat dasbor persiapan" },
  manage_prep_config: { en: "Manage prep config", id: "Kelola konfigurasi persiapan" },
  // Kitchen & warehouse
  switch_warehouse: { en: "Switch warehouse", id: "Ganti gudang" },
  // Price changes
  view_price_changes: { en: "View price changes", id: "Lihat perubahan harga" },
  create_price_change: { en: "Create price change", id: "Buat perubahan harga" },
  approve_price_change: { en: "Approve price change", id: "Setujui perubahan harga" },
  // AI
  view_ai_assistant: { en: "View AI assistant", id: "Lihat asisten AI" },
  view_recipe_coverage: { en: "View recipe coverage", id: "Lihat cakupan resep" },
  view_ai_cfo: { en: "View AI CFO", id: "Lihat AI CFO" },
  // Finance
  view_finance_dashboard: { en: "View finance dashboard", id: "Lihat dasbor keuangan" },
  view_profit_loss: { en: "View profit & loss", id: "Lihat laba rugi" },
  view_cash_flow: { en: "View cash flow", id: "Lihat arus kas" },
  view_finance_categories: { en: "View finance categories", id: "Lihat kategori keuangan" },
  manage_finance_categories: { en: "Manage finance categories", id: "Kelola kategori keuangan" },
  manage_finance_entries: { en: "Manage finance entries", id: "Kelola entri keuangan" },
  view_finance_advanced: { en: "View advanced finance", id: "Lihat keuangan lanjutan" },
  view_owner_wealth: { en: "View owner wealth", id: "Lihat kekayaan pemilik" },
  // Accounting
  view_accounting: { en: "View accounting", id: "Lihat akuntansi" },
  manage_accounting: { en: "Manage accounting", id: "Kelola akuntansi" },
  // Data integrity
  view_integrity: { en: "View data integrity", id: "Lihat integritas data" },
  reverse_transaction: { en: "Reverse transaction", id: "Balikkan transaksi" },
  force_correct: { en: "Force correct", id: "Koreksi paksa" },
  hard_delete: { en: "Hard delete", id: "Hapus permanen" },
  system_reset: { en: "System reset", id: "Reset sistem" },
  manage_implementation_mode: { en: "Manage implementation mode", id: "Kelola mode implementasi" },
  // Bank import
  view_bank_import: { en: "View bank import", id: "Lihat impor rekening koran" },
  upload_bank_statement: { en: "Upload bank statement", id: "Unggah rekening koran" },
  approve_bank_import: { en: "Approve bank import", id: "Setujui impor rekening koran" },
  // HRD
  view_hr_dashboard: { en: "View HR dashboard", id: "Lihat dasbor HRD" },
  view_employees: { en: "View employees", id: "Lihat karyawan" },
  manage_employees: { en: "Manage employees", id: "Kelola karyawan" },
  view_attendance: { en: "View attendance", id: "Lihat absensi" },
  manage_attendance: { en: "Manage attendance", id: "Kelola absensi" },
  view_kpi: { en: "View KPI", id: "Lihat KPI" },
  manage_kpi: { en: "Manage KPI", id: "Kelola KPI" },
  view_training: { en: "View training", id: "Lihat pelatihan" },
  manage_training: { en: "Manage training", id: "Kelola pelatihan" },
  view_payroll_preview: { en: "View payroll preview", id: "Lihat pratinjau penggajian" },
  manage_payroll: { en: "Manage payroll", id: "Kelola penggajian" },
  manage_hr_settings: { en: "Manage HR settings", id: "Kelola pengaturan HRD" },
};

export const permLabel = (key, lang) => (PERMISSION_LABELS[key]?.[lang] || PERMISSION_LABELS[key]?.en || key);
export const moduleLabel = (key, lang) => (MODULE_LABELS[key]?.[lang] || MODULE_LABELS[key]?.en || key);
